import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { defineCustomElements } from '@britishairways-ent/bagel/loader';

import { AppModule } from './app/app.module';
import { config } from './environments/environment';

if (config.production) {
  enableProdMode();
}

//  OneTrust Cookie Consent block dynamically replaced in the index.html file
(window as any).__onetrustConfig = config.oneTrust;
 const script = document.createElement('script');
script.src = config.oneTrust.srcUrl;
script.setAttribute('data-domain-script', config.oneTrust.dataDomainScript);
script.type = 'text/javascript';
script.async = true;
const placeholder = document.getElementById('onetrust-script-placeholder');
placeholder?.replaceWith(script);

defineCustomElements(window, { resourcesUrl: '/bagel/' });

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
